import { hasClass, setAttribute } from 'modules/dom'
import { addQueryVar, removeQueryVar, map } from 'modules/utils'
import { loadFormatDate } from './date'

/**
 * Load keys and values into Object, but format date string
 * @param {Array} values
 * @param {Array} keys
 * @returns {Object} result
 */
const getTimeObject = (values, keys, format) => {
  let result = {}

  if (!format) {
    format = 'YYYY - M - dd'
  }

  if (!keys || !values) {
    return {}
  }

  map((objectKey, index) => {
    const valueDate = new Date(values[index])

    result[objectKey] = loadFormatDate(valueDate, format)
  }, keys)

  return result
}

/**
 *
 * @param {Object} currentDate
 * @param {Object} startDate
 * @param {Object} endDate
 * @param {Array} objectKeys
 * @param format
 * @returns {{}}
 */
const getTimes = (currentDate, startDate, endDate, objectKeys, format = '') => {
  if (!startDate) {
    startDate = currentDate
  }

  if (!endDate) {
    endDate = currentDate
  }

  if (!objectKeys || objectKeys.length < 1) {
    objectKeys = ['currentStart', 'activeStart', 'activeEnd']
  }

  if (!format) {
    format = 'YYYY - M - dd'
  }

  const values = [currentDate, startDate, endDate]

  return getTimeObject(values, objectKeys, format)
}

const hasNextCalendarButton = hasClass('js-calendar-next')
const hasPrevCalendarButton = hasClass('js-calendar-prev')
const hasNextAndPrevButtons = (elm) => hasNextCalendarButton(elm) && hasPrevCalendarButton(elm)

/**
 * Helper function to add &key=value to page url
 * @param {string} url
 * @param {Object} timeObject
 * @returns {string}
 */
const addQueryVars = (url, timeObject) => {
  const entries = Object.entries(timeObject)
  map(entry => {
    url = addQueryVar(entry[0], entry[1], url)
  }, entries)

  window.history.pushState('newPage', document.title, url)

  return url
}

/**
 * Remove multiple &key=value
 * @param {string} url
 * @param {Array} queryVars
 * @returns {*}
 */
const removeQueryVars = (url, queryVars) => {
  map(queryVar => {
    removeQueryVar(queryVar, url)
  }, queryVars)

  return url
}

/**
 * Set data attributes from calendarAttributes
 * @param {Node} element
 * @param {Object} timeObject
 * @returns {string|*}
 */
const setDataAttributes = (element, timeObject) => {
  if (!element) {
    return ''
  }

  const calendarAttributes = ['current', 'start', 'end']
  const values = Object.values(timeObject)

  map((value, index) => {
    if (element && value) {
      setAttribute(`data-${calendarAttributes[index]}`, value, element)
    }
  }, values)

  return element
}

/**
 * Create a context (HTML) from an array
 * @param {Array} data
 * @returns {string}
 */
const getMobileHtmlContext = (data) => {
  let contentHtml = ``
  console.log('data', data)
  if (data && data.length) {
    map((item) => {
      contentHtml += `<div class="webinar-popover-mobile__item">
        ${item['webinar_tag'] ? `<span class="label card-list__category-tag" style="background-color:${item['webinar_tag_color']}">${item['webinar_tag']}</span>` : ''}
        ${item['category'] ? `<div class="label webinar-popover-mobile__category">${item['category']}</div>` : ''}
        ${item['title'] ? `<h2 class="sub-heading2 webinar-popover-mobile__title">${item['title']}</h2>` : ``}
        ${item['excerpt'] ? `<div class="p webinar-popover-mobile__description">${item['excerpt']}</div>` : ''}
        ${item['clock'] ? `<div class="p-small webinar-popover-mobile__time">${item['clock']}</div>` : ''}
        ${item['url'] ? `<a href="${item['url']}" class="button card-list_more-link">See ${item['label'] ? item['label'] : ''}</a>` : ''}
      </div>`
    }, data)
  }

  return contentHtml
}

/**
 *
 * @param {Object} obj
 * @param {Object} changeKeys
 * Example changeKeys: {tag: category}
 * @returns {Object}
 */
const syncObjectKeys = (obj, changeKeys) => {
  const objEntries = Object.entries(obj)
  const oldKeys = Object.keys(changeKeys)
  const newKeys = Object.values(changeKeys)

  const results = map(objEntry => {
    let [key, value] = objEntry

    if (oldKeys.indexOf(key) !== -1) {
      key = newKeys[oldKeys.indexOf(key)]
    }

    return {
      [key]: value
    }
  }, objEntries)

  // Convert array to object
  return results.reduce(function(result, item) {
    const key = Object.keys(item)[0]
    result[key] = item[key]
    return result
  }, {})
}

export {
  addQueryVars,
  removeQueryVars,
  getTimes,
  getMobileHtmlContext,
  hasNextCalendarButton,
  hasPrevCalendarButton,
  hasNextAndPrevButtons,
  setDataAttributes,
  syncObjectKeys
}
